import Order from './Order'
import OrderCreating from './OrderCreating'
import OrderResponse from './OrderResponse'
import UserOrder from './UserOrder'
import Checkout from './Checkout'
import QuoteButton from './QuoteButton'

Vue.component('Order', Order)
Vue.component('OrderCreating', OrderCreating)
Vue.component('OrderResponse', OrderResponse)
Vue.component('UserOrder', UserOrder)
Vue.component('Checkout', Checkout)
Vue.component('QuoteButton', QuoteButton)



// WEBPACK FOOTER //
// ./src/js/components/Order/index.js